import { render, staticRenderFns } from "./BgBody.vue?vue&type=template&id=03a98275&"
import script from "./BgBody.vue?vue&type=script&lang=js&"
export * from "./BgBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports